import React from 'react';
import { arrayOf, node, oneOfType, shape, string } from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const headerStyles = theme => ({
  backgroundColor: theme.palette.graphic.lighter,
  color: theme.palette.primary.dark,
  padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
});
const itemStyles = theme => ({
  backgroundColor: theme.palette.surface.medium,
  borderBottom: `solid 1px ${theme.palette.graphic.light}`,
  display: 'flex',
  gap: theme.spacing(2),
  justifyContent: 'space-between',
  padding: theme.spacing(2),
});
const subheaderStyles = theme => ({
  background: theme.palette.graphic.light,
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
});

const SummaryStep = ({ emptyValueText, headerTitle, sections, subtitleVariant }) => {
  return (
    <>
      <Typography color="inherit" sx={headerStyles} variant={subtitleVariant}>
        {headerTitle}
      </Typography>

      {sections.map(({ rows, title }) => (
        <React.Fragment key={title}>
          <Typography color="textPrimary" sx={subheaderStyles} variant={subtitleVariant}>
            {title}
          </Typography>
          {rows.map(({ label, value }) => (
            <Box key={`${title}-${label}`} sx={itemStyles}>
              <Typography sx={{ color: 'text.secondary' }} variant="body1">
                {label}
              </Typography>
              <Typography
                sx={{ color: 'text.primary', textAlign: 'right' }}
                variant={subtitleVariant}
              >
                {value || emptyValueText}
              </Typography>
            </Box>
          ))}
        </React.Fragment>
      ))}
    </>
  );
};

export default SummaryStep;

SummaryStep.propTypes = {
  emptyValueText: string,
  headerTitle: string,
  sections: arrayOf(
    shape({
      rows: arrayOf(
        shape({
          label: string.isRequired,
          value: oneOfType([node, string]),
        })
      ).isRequired,
      title: string.isRequired,
    })
  ),
  subtitleVariant: string,
};

SummaryStep.defaultProps = {
  emptyValueText: '-',
  headerTitle: 'Summary',
  sections: [],
  subtitleVariant: 'subtitle1',
};
